import client from './client.svg';
import dashboard from './dashboard.svg';
import development from './development.svg';
import house from './house.svg';
import order from './order.svg';
import seed from './seed.svg';
import transport from './transport.svg';
import user from './user.svg';

export default {
  Client: client,
  Dashboard: dashboard,
  Development: development,
  House: house,
  Order: order,
  Seed: seed,
  Transport: transport,
  User: user,
};
